unit uMain;

interface

uses
  System.SysUtils, System.Classes, system.StrUtils,  JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs,  Vcl.StdCtrls,    x.FileServiceTypes,
  WEBLib.StdCtrls, WEBLib.ExtCtrls,    xweb.FileService, Vcl.Controls, xweb.webman,xdata.Web.Client,
  WEBLib.WebCtrls, dateutils ;


type
  TForm3 = class(TForm)
    WebEdit1: TEdit;
    WebLabel1: TLabel;

    procedure WebEdit1KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
  public
   LastSearch: tdateTime;
   LoadMoreButton: tJSElement;
   NextIconsButton: tJSElement;
   FilterIconsButton: tJSElement;
   firstInteger: integer;
   lastInteger: integer;
   files: txFileService;
   Icons: tbsFileList;
   [async]
   procedure DisplayIcons; async;
   procedure UploadError(s: string; aError: string) ;
   procedure UploadOK(s: string; aError: string) ;
     [async]
   procedure fsConnected(sender: tobject); async;
   procedure filterIcons2(s: string);
   function loadIcons(aEvent: TJSMouseEvent): boolean;
   function nextIcons(aEvent: TJSMouseEvent): boolean;
   function filterIcons(aEvent: TJSMouseEvent): boolean;

  // procedure ServerErrorEvent(Error: TXDataWebConnectionError);
  protected procedure LoadDFMValues; override; end;

var
  Form3: TForm3;

implementation

{$R *.dfm}

procedure TForm3.WebFormCreate(Sender: TObject);
begin
  console.log('Hello');
  webman.DefaultSite := webman.site('x.am1.com');
  webman.DefaultSite.setv('XdAuth', 'https://x.am1.com:443/fs2');

  files := tXFileService.Create;
  files.OnFileError := UploadError;
  files.onFileOK := UploadOK;
  //files.OnError := ServerErrorEvent;
  files.onConnected := fsConnected;
  files.connected:=true;

end;


procedure TForm3.filterIcons2(s: string);
var
 i: integer;
 aIcon: tbsFile;
 iconResult: TJSHtmlElement ;
 xx: integer;
begin
  xx:=0;
  for i:=firstInteger to lastInteger do
    begin

    aicon:=icons.files[i-1];
    IconResult:=TJSHtmlElement(aIcon.UIObject);

    if lowercase(ExtractFileExt(aIcon.FullFN))='.svg' then

      if ((pos(s, lowercase(aicon.fullfn))<>0) or (s='')) then
        begin
          xx:=xx+1;
          iconResult.className:= 'col-6 col-md-2 col-lg-1';
        end else
        begin
          iconResult.className:= 'col-6 col-md-2 col-lg-1 d-none';
        end;
  end;
  weblabel1.Caption:=Inttostr(xx) + ' icons';
end;

function TForm3.filterIcons(aEvent: TJSMouseEvent): boolean;
var
 i: integer;
 aIcon: tbsFile;
 iconResult: TJSHtmlElement ;
begin

   for i:=firstInteger to lastInteger do
   begin

   aicon:=icons.files[i-1];
   IconResult:=TJSHtmlElement(aIcon.UIObject);

   if lowercase(ExtractFileExt(aIcon.FullFN))='.svg' then

    if pos('settings', lowercase(aicon.fullfn))<>0 then
     begin

       //make it vis
       iconResult.className:= 'col-6 col-md-2 col-lg-1';
     end else
     begin
      //make it invis
       iconResult.className:= 'col-6 col-md-2 col-lg-1 d-none';
     end;
  end;

end;

procedure TForm3.fsConnected(sender: tobject);
var
  loadingSpinner: TJSElement;

begin
  console.log('Connected');
  icons:=await(tbsFileList,files.GetFiles('d:\libx\icons', '*.*', true));
  firstInteger:= 1;
  lastInteger:= icons.files.count;
  DisplayIcons;
  loadingSpinner := document.getElementbyId('initial_loader');
  loadingSpinner.className:= 'd-none';

 //alert('this is an alert');
end;

function TForm3.loadIcons(aEvent: TJSMouseEvent): boolean;
begin
    firstInteger:= 1;
    lastInteger:= icons.files.count;
    DisplayIcons;
end;

function TForm3.nextIcons(aEvent: TJSMouseEvent): boolean;
begin
    firstInteger:= 101;
    lastInteger:= 200;
    DisplayIcons;
end;

procedure TForm3.DIsplayIcons;
var
 aPanel: TPanel;
 aImage: TImageControl;
 alabel: Tlabel;
 aIcon: tbsFile;
 i: integer;
 c: integer;
 iconsContainer: TJSElement;
 iconResult: TJSElement;
 iconResultCard: TJSElement;
 iconResultCardImage: TJSElement;
 iconResultCardTitle: TJSElement;
 iconResultCardCreated: TJSElement;
 iconResultCardType: TJSElement;
 iconResultCardSize: TJSElement;
 delimiterPos: Integer;
begin
 i:=firstInteger;
 c:= 0;

 for i:=firstInteger to lastInteger do
   begin

   aicon:=icons.files[i-1];

     if lowercase(ExtractFileExt(aIcon.FullFN))='.svg' then

     begin

       delimiterPos := LastDelimiter('\',extractfilename(aicon.FullFN));

       iconsContainer:= document.getElementById('icon_results');

       iconResult := document.createElement('div');
       aicon.UIObject:=tobject(iconResult);
       iconResult.className:= 'col-6 col-md-2 col-lg-1';

       iconResultCard := document.createElement('div');
       iconResultCard.className:= 'card p-2 h-100 border-0';

       iconResultCardImage := document.createElement('div');
       iconResultCardImage.className:= 'card-image';

       iconResultCardImage.innerHTML :=
       stringReplace(
       '''
          <img src="$$$" class="card-img-top" alt="...">

       ''', '$$$', aIcon.url, []);

       iconResultCardTitle := document.createElement('div');
       iconResultCardTitle.className:= 'pt-2';

       iconResultCardTitle.innerHTML :=
       stringReplace(
       '''
            <small><p class="card-text text-center">$$$</p></small>

       ''', '$$$', copy(extractfilename(aicon.FullFN),delimiterPos+1, length(extractfilename(aicon.FullFN))-delimiterPos-4), []);

       iconResultCardType := document.createElement('div');
       iconResultCardType.className:= '';

       iconResultCardType.innerHTML :=
       stringReplace(
       '''
            <small><p class="card-text">File Type: $$$</h5></small>

       ''', '$$$', aIcon.ext, []);

       iconResultCardSize := document.createElement('div');
       iconResultCardSize.className:= '';

       iconResultCardSize.innerHTML :=
       stringReplace(
       '''
            <small><p class="card-text">File Size: $$$</p></small>

       ''', '$$$', inttostr(aIcon.Size), []);

       iconResultCardCreated := document.createElement('div');
       iconResultCardCreated.className:= '';

       iconResultCardCreated.innerHTML :=
       stringReplace(
       '''
            <small><p class="card-text">Created: $$$</p></small>

       ''', '$$$', aIcon.WriteTimeS, []);

       iconResultCard.appendChild(iconResultCardImage);
       iconResultCard.appendChild(iconResultCardTitle);
       //iconResultCard.appendChild(iconResultCardType);
       //iconResultCard.appendChild(iconResultCardSize);
       //iconResultCard.appendChild(iconResultCardCreated);
       iconResult.appendChild(iconResultCard);
       iconsContainer.appendChild(iconResult);

       console.log(extractfilename(aicon.FullFN));
       console.log(AnsiReplaceStr(extractfilename(aicon.FullFN), '\libx\icons\', ''));
       console.log(copy(extractfilename(aicon.FullFN), 0, delimiterPos));
       console.log(AnsiReplaceStr(copy(extractfilename(aicon.FullFN), 0, delimiterPos-1), '\libx\icons\', ''));
       c:=c+1;
     end;
   end;
end;

{procedure TForm3.ServerErrorEvent(Error: TXDataWebConnectionError);
begin

end;   }

procedure TForm3.UploadError(s, aError: string);
begin

end;

procedure TForm3.UploadOK(s, aError: string);
begin

 end;

procedure TForm3.WebEdit1KeyUp(Sender: TObject; var Key: Word; Shift:
    TShiftState);
begin

if key=VK_ESCAPE then
 begin
    webedit1.Text:='';
 end;
 FilterIcons2(WebEdit1.Text);
 LastSearch:=now;

end;

procedure TForm3.WebFormShow(Sender: TObject);
begin
    //LoadMoreButton := document.getElementbyId('load_icons_button');
    //LoadMoreButton.addEventListener('click', @loadIcons);

    //NextIconsButton := document.getElementbyId('next_icons_button');
    //NextIconsButton.addEventListener('click', @nextIcons);

    //FilterIconsButton := document.getElementbyId('filter_icons_button');
    //FilterIconsButton.addEventListener('click', @filterIcons);
end;

procedure TForm3.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create('icon_results_count');
  WebEdit1 := TEdit.Create('icon_search_input');

  WebLabel1.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  try
    Name := 'Form3';
    Width := 640;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 184;
    WebLabel1.Width := 5;
    WebLabel1.Height := 25;
    WebLabel1.Margins.Left := 3;
    WebLabel1.Margins.Top := 3;
    WebLabel1.Margins.Right := 3;
    WebLabel1.Margins.Bottom := 3;
    WebLabel1.ElementFont := efCSS;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -18;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebEdit1.SetParentComponent(Self);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 224;
    WebEdit1.Top := 64;
    WebEdit1.Width := 184;
    WebEdit1.Height := 48;
    WebEdit1.Margins.Left := 3;
    WebEdit1.Margins.Top := 3;
    WebEdit1.Margins.Right := 3;
    WebEdit1.Margins.Bottom := 3;
    WebEdit1.ElementClassName := 'form-control';
    WebEdit1.ElementFont := efCSS;
    WebEdit1.HeightStyle := ssAuto;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.WidthPercent := 100.000000000000000000;
    SetEvent(WebEdit1, Self, 'OnKeyUp', 'WebEdit1KeyUp');
  finally
    WebLabel1.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
  end;
end;

end.
